import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { Validators,FormBuilder, FormGroup} from '@angular/forms';
import { ServiceProviderService } from '../../service/serviceprovider.service';
import { serviceprovider } from '../../domain/serviceprovider';
import { User } from '../../domain/user';
import { usermaintenanceservice } from '../../service/usermaintenanceservice';
import { hubservice } from '../../service/hubservice';
import { hubs } from '../../domain/hubs';
import { locationservice } from '../../service/locationservice';
import { locations } from '../../domain/locations';
import { ScheduleStaffing } from '../../domain/ScheduleStaffing';
import { schedulestaffingservice } from '../../service/schedulestaffingservice';
import { flexperiodsservice } from '../../service/flexperiodsservice';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-staffingupdate',
  templateUrl: './staffingupdate.component.html',
  styleUrls: ['./staffingupdate.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default

})
export class StaffingUpdateComponent implements OnInit {
  serviceproviderlist: serviceprovider[];
  largeProviderModal: boolean;
  isSubmitted: boolean;
  isEditSubmitted: boolean;
  updateLargeProviderModal: boolean;
  selected_Provider: serviceprovider;
  update_LargeProvider_Submitted: boolean;
  LargeProvider_type: any;
  msgs1: Message[];   
  msgs2: Message[];
  progressbar:boolean=false;
  selectedtitle:any;
  requestedPeriodDetails: string;
  titles = [
    {name: 'Senior Field Officer', value: 'SFO'},
    {name: 'Field Officer', value: 'FO'},
   
   
  ];

  targetMessages: { severity: string; summary: string; detail: string; }[];
   constructor(public fb: FormBuilder, private messageService:MessageService, private hubservice: hubservice,
    private usermaintenanceservice: usermaintenanceservice, private locationservice: locationservice
    ,private flexperiodService: flexperiodsservice,private cd: ChangeDetectorRef
  , private scheduleStaffingservice: schedulestaffingservice, private confirmationService: ConfirmationService) { 
  
   }

   


   registerForm: FormGroup;
   
  addlargeproviderform = this.fb.group({
    flprovidername: ['', [Validators.required]],
  });   

 
  users: User[];
  usersbackup : User[];
  selecteduserdetails : User;
  userhub:string =""; 
  loginuserId: string ="";
  messagepopup:string="";
  submissioncutOffDate:string;
  submitdueDate:Date;
  ngOnInit(): void {

    

    this.progressbar=true;


    //get details for current user
     this.loginuserId =localStorage.getItem("loginuserid");

    this.usermaintenanceservice.get(this.loginuserId).subscribe(userdata =>{   
      this.selecteduserdetails = userdata;
      if(this.selecteduserdetails)
      {
        this.userhub=this.selecteduserdetails.region;

        //check if submitted or not
      //this.userhub
      console.log("this.userhub"+this.userhub)
      
      this.scheduleStaffingservice.getPendingStaffingRequest(this.userhub,).subscribe(res=>{
        console.log("res"+res)
        if(res)
        {
          //check if submitted but not approved
          this.hubComments = res.hubCoComments;

          this.requestedPeriodDetails = res.periodDetails;

          console.log("res.periodName"+res.periodName)
          
        
          if(res.requestSubmitFlag!=null && res.requestSubmitFlag=='Y')
          {
            this.submitstatus=false;// it is already submitted by hubco
            this.msgs1 = [
              {severity:'success', summary:'', detail:'You have already submitted the staffing update for ' + res.periodName + '.'}
              
          ];
          }
          else{
            this.submitstatus=true;    // show a message on the top of page
             //GET FLEXDETAILS
             const datepipe: DatePipe = new DatePipe('en-AU')

             this.flexperiodService.getActiveFlexPeriods().subscribe(flexdata => {
              let foundData = flexdata.filter(e=>e.perName===res.periodName);
              if(foundData && foundData.length>0)
              {
                this.submissioncutOffDate= datepipe.transform(foundData[0].staffReportCutOffDate, 'dd/MM/yyyy') ;
                this.submitdueDate=foundData[0].staffReportCutOffDate;
              }
              this.msgs1 = [
                {severity:'error', summary:'', detail:'You have a pending staffing update to submit for Period ' + res.periodDetails + " Please submit before due date: " + this.submissioncutOffDate }
                
            ];
            }
            )

          
          }
        }else{
          this.submitstatus=false;// it is already submitted by hubco

          this.msgs2 = [
            {severity:'info', summary:'', detail:'You have nothing to report' }
            
        ];

        }
      })

      this.locationservice.getLocations().subscribe(locationData=>{
        if(locationData)
        {
        this.allLocations=locationData;

        if(this.allLocations)
        {

        this.usermaintenanceservice.getAllUsers().subscribe(userdata =>{      
          if(userdata!=null){
            this.users =userdata.filter(el=>el.status=='Active' && el.roleId!='SOM' && el.region==this.userhub);
             let jsonArray = JSON.parse(JSON.stringify(this.allLocations));

            this.users.forEach(eledata=>{
              eledata.userFullName = eledata.userFirstName + " " + eledata.userLastName;
              let myobj = jsonArray.find(el=>el.locationId===eledata.prefLocationOne);
              if(myobj)
              {
                eledata.prefLocationName = myobj.locationName;
              }
              if(eledata.travelStatus)
              {
              eledata.travelStatusBoolean = (eledata.travelStatus==='true'); 
              }
              if(eledata.hubcoSubmissionStatus)
                {
                eledata.hubcoSubmissionStatusBoolean = (eledata.hubcoSubmissionStatus==='true'); 
                }
                if(eledata.twofourone)
                  {
                  eledata.twofouroneBoolean = (eledata.twofourone==='true'); 
                  }
            
            
              // show only active users
            //  this.users.push(eledata);
             
            }); 
            this.usersbackup=this.users;
            this.progressbar=false;
    
          }
    
          this.gethubs();
         
    
         
          
    
         
        });

      }
      
        }
      })
    
  


      }
    });

  
    //get all users details

  
    this.registerForm = this.fb.group({

      /* for edit */
      updatelargeprovidergroup : this.fb.group({
        flprovidername:['', [Validators.required]],
      //  ftarget_status:['', [Validators.required]],
      }),
      
    });
  }
  //get largeproviders() { return (<FormGroup>this.registerForm.get('updatelargeprovidergroup')).controls; }
hubs: hubs;
selectedHub:any;
  gethubs(){
    this.hubservice.getHubs().subscribe(hubData=>{
      this.hubs=hubData;
   //   console.log("-- all hubs--"+ this.hubs);

    })
  }

  filterForHub()
  {
    this.users=this.usersbackup.filter(el=>el.region==this.selectedHub);

  }

  allLocations: locations;


  changePrefLocation(userselected:User,selectedPrefLocation:any)
  {
    console.log("selectedPrefLocation value"+selectedPrefLocation.value)
    if(selectedPrefLocation && selectedPrefLocation.value)
    {
    this.locationservice.getLocationsforId(selectedPrefLocation.value).subscribe(resp=>{
      console.log("resp.locationName"+resp.locationName)

      if(resp && resp.locationName=='Other')
      {
        this.messageService.add({severity:'info', summary: 'Info', detail:'please provide details of new Location in notes'});

      }
    })
    this.usermaintenanceservice.get(userselected.userId).subscribe(res=>{
      if(res)
      {
        res.prefLocationOne=selectedPrefLocation.value;
       

        this.usermaintenanceservice.update(res).subscribe(re =>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'Suburb/Preferred Lccation updated successfully'});

        },err=>{
          this.messageService.add({severity:'Error', summary: 'Error', detail:'Suburb/Preferred LOcation update failed'});

        })

      }
    })
  }
  }
  onEdit(event:any)
  {

    console.log(event.field)
  
   if(event && event.data && this.submitstatus)
      {
        let user = event.data;
        this.usermaintenanceservice.get(user.userId).subscribe(res=>{
          if(res)
          {
            res.staffingNotes=user.staffingNotes;
            res.prefLocationOne=user.prefLocationOne;
            res.title = user.title;
            if(user.title == 'SFO' || user.title == 'FO')
              {
                res.roleId='ACO'
              }
      
              if(user.title== 'SFORD' || user.title == 'FORD')
                {
                  res.roleId='SCHD_ACO_READONLY'
                }

            if(user.prefLocationOne && event.field=='prefLocationOne')
            {
              
              this.locationservice.getLocationsforId(user.prefLocationOne).subscribe(resploc=>{
                user.prefLocationName = this.getLocationName(user.prefLocationOne);
                if(resploc && resploc.locationName=='Other')
                {
                  this.messageService.add({severity:'info', summary: 'Info', detail:'Please enter new officer location in Notes.'});

                }
              })
            }

    
            this.usermaintenanceservice.update(res).subscribe(re =>{
              this.messageService.add({severity:'success', summary: 'Success', detail:'Staffing notes updated successfully'});
    
            },err=>{
              this.messageService.add({severity:'error', summary: 'Error', detail:'Staffing notes update failed'});
    
            })
    
          }
        })
      }

  }

  saveHubComments()
  {
    this.scheduleStaffingservice.getPendingStaffingRequest(this.userhub).subscribe(res=>{
      if(res)
      {
        let staffingREquest: ScheduleStaffing;
        staffingREquest = res;
        staffingREquest.hubCoComments = this.hubComments;
        console.log("this.hubComments"+this.hubComments)
        this.scheduleStaffingservice.update(staffingREquest).subscribe(data=>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'Comments saved successfully'});
         

        },err=>{
          this.messageService.add({severity:'error', summary: 'Error', detail:'Comments save error'});

        })



      }
    })

  }

  updateTravelstatus(user:User)
  {
    if(this.submitstatus)
    {
    console.log("user.travelStatus"+user.travelStatus)
    this.usermaintenanceservice.get(user.userId).subscribe(res=>{
      if(res)
      {
        
          user.travelStatus = user.travelStatusBoolean.toString();
      
        res.travelStatus=user.travelStatus;
      
        this.usermaintenanceservice.update(res).subscribe(re =>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'Travel Status updated successfully'});

        },err=>{
          this.messageService.add({severity:'error', summary: 'Error', detail:'Travel Status update failed'});

        })

      }
    })
  }
  }
  updateTwoforone(user: User)
  {
    if(this.submitstatus)
      {
    this.usermaintenanceservice.get(user.userId).subscribe(res=>{
      if(res)
      {
        res.twofourone=user.twofouroneBoolean.toString();
        user.twofourone=user.twofouroneBoolean.toString();
      
        this.usermaintenanceservice.update(res).subscribe(re =>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'2-4-1 Status updated successfully'});

        },err=>{
          this.messageService.add({severity:'error', summary: 'Error', detail:'2-4-1 Status update failed'});

        })

      }
    })
  }

  }
  updateSubmission(user: User)
  {
    if(this.submitstatus)
      {
    this.usermaintenanceservice.get(user.userId).subscribe(res=>{
      if(res)
      {
        res.hubcoSubmissionStatus=user.hubcoSubmissionStatusBoolean.toString();
        user.hubcoSubmissionStatus=user.hubcoSubmissionStatusBoolean.toString();
      
        this.usermaintenanceservice.update(res).subscribe(re =>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'Status updated successfully'});

        },err=>{
          this.messageService.add({severity:'error', summary: 'Error', detail:'Status Status update failed'});

        })

      }
    })
  }
  }
  submitstatus = true;
  hubComments:string = "";
  submitStaffUpdate()
  {
    let today = new Date();
    var validtilldate = new Date(this.submitdueDate.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
    validtilldate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    console.log(today)
    console.log(validtilldate)

    if(today>validtilldate)
    {
     // console.log("true"+true) change here
     this.messageService.add({severity:'error', summary: 'Error', detail:'You are past the due date: '+this.submissioncutOffDate});
     return;

    }

    else{
  
    this.confirmationService.confirm({
      message: 'Do you want to Submit?',
      accept: () => {

        let uncheckedlist  = this.users.filter(el=>(el.hubcoSubmissionStatus==null || el.hubcoSubmissionStatus==undefined || el.hubcoSubmissionStatus=='false'))
        if(uncheckedlist && uncheckedlist.length>0)
            {
            this.messageService.add({severity:'error', summary: 'Error', detail:'Please select all records as done to proceed'});
            return;
          }
         else{
          //all good to submit
    
         
          this.scheduleStaffingservice.getPendingStaffingRequest(this.userhub).subscribe(res=>{
            if(res)
            {
              let staffingREquest: ScheduleStaffing;
              staffingREquest = res;
              staffingREquest.requestSubmitDate= new Date();
              staffingREquest.requestSubmitFlag= 'Y';
              staffingREquest.requestSubmittedBy= this.loginuserId;
              staffingREquest.hubCoComments = this.hubComments;
              console.log("this.hubComments"+this.hubComments)
              this.scheduleStaffingservice.update(staffingREquest).subscribe(data=>{
                this.submitstatus = false;
                this.messageService.add({severity:'success', summary: 'Success', detail:'Staffing updates have been submitted.'});

                this.msgs1=[];
                this.cd.detectChanges();
                this.scheduleStaffingservice.sendStaffingEmail('SubmitStaffUpdate',staffingREquest.hubName, staffingREquest.periodName).subscribe(resp=>{
                  if(resp)
                  {
    
                    console.log("email for submission is sent")
                    
                  }
                },err=>{
                  this.messageService.add({severity:'error', summary: 'Error', detail:'Error while sending email to Hub Coordinator'});
    
                })
    
              },err=>{
                this.messageService.add({severity:'error', summary: 'Error', detail:'failed to submit'});
    
              })
    
    
    
            }
          })
    
          
         }
        

      }
    })

 
  }
    
  }

  saveStaffingNotes(userselected:User)
  {
    
    if(userselected)
    {
      this.usermaintenanceservice.get(userselected.userId).subscribe(res=>{
        if(res)
        {
          res.staffingNotes=userselected.staffingNotes;
         
  
          this.usermaintenanceservice.update(res).subscribe(re =>{
            this.messageService.add({severity:'success', summary: 'Success', detail:'Staffing notes updated successfully'});
  
          },err=>{
            this.messageService.add({severity:'failure', summary: 'Failure', detail:'Staffing notes update failed'});
  
          })
  
        }
      })
    }
    
  }
  

 // defaultLocations: locations ={locationId:'1',locationName:'Other'};

  getAllLocations(){
    this.locationservice.getLocations().subscribe(locationData=>{
      if(locationData)
      {
      this.allLocations=locationData;
     /* let jsonArray = JSON.parse(JSON.stringify(locationData));
      jsonArray.push(this.defaultLocations);
      this.allLocations = jsonArray;*/
      
    //  console.log(this.allLocations);
      }
    })
  }


  getLocationName(id:string)
  {
    if(this.allLocations)
    {
    let jsonArray = JSON.parse(JSON.stringify(this.allLocations));
    let myobj = jsonArray.find(el=>el.locationId===id);
    if(myobj!=null)
    {
      return myobj.locationName;
    }
    else{
      return "";
        }
      }
      else{
        return "";
      }

  }

  getTitlename()
  {

  }
  //added to reset the form after submited
  formReset(){
   /* this.addlargeproviderform = this.fb.group({
      fflprovidername: ['', [Validators.required]],
    });*/
  }


  changeRole(userselected:User,selectedtitle:any)
  {
    if(selectedtitle)
    {
    let newtitle = this.titles.find(el=>el.value=selectedtitle.value);
    this.usermaintenanceservice.get(userselected.userId).subscribe(res=>{
      if(res)
      {
        res.title=newtitle.value;
        console.log("res.title"+res.title)
        if(res.title == 'SFO' || res.title == 'FO')
        {
          res.roleId='ACO'
        }

        if(res.title == 'SFORD' || res.title == 'FORD')
          {
            res.roleId='SCHD_ACO_READONLY'
          }

        this.usermaintenanceservice.update(res).subscribe(re =>{
          this.messageService.add({severity:'success', summary: 'Success', detail:'Role updated successfully'});

        },err=>{
          this.messageService.add({severity:'failure', summary: 'Failure', detail:'Role update failed'});

        })

      }
    })
  }
  }


  openProviderModal(providertypes){
    this.update_LargeProvider_Submitted = false;
    this.updateLargeProviderModal = true;
    this.selected_Provider= providertypes;
    this.selected_Id();
  }
 
  selected_Id() {

    this.updatelargeprovidergroup.patchValue({
      flargeProviderName: this.selected_Provider.largeProviderName,

    });
  }




  selectedServiceProvider:serviceprovider;
  spediting:boolean = false;
  onRowEditSPInit(serviceProvider: serviceprovider){
    this.selectedServiceProvider = {...serviceProvider};
    this.spediting = true;
}
serviceProvider:serviceprovider;
onRowEditSPCancel(serviceProvider: serviceprovider, index: number) {
         
  this.serviceProvider=this.serviceproviderlist.filter(el=>(el.serviceProviderId === serviceProvider.serviceProviderId))[0];
  this.serviceproviderlist[this.serviceproviderlist.indexOf(this.serviceProvider)] = this.selectedServiceProvider;
  this.spediting = false;
}
onRowEditSPSave(serviceProvider: serviceprovider) {
  serviceProvider.updatedBy = localStorage.getItem("loginuserid");
  serviceProvider.updatedDate = new Date();
  this.spediting = false;

 /* this.serviceprovidersservice.updateSPDetail(serviceProvider).subscribe(res=>{           
      console.log(res);  
          
      this.messageService.add({severity:'success', summary: 'Success', detail:'Service Provider detail updated successfully'});
  },err=>{      
      console.log(err);        
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Service Provider detail update failed' });
  })*/
}


  
  showlargeprovidermodel(){
    this.isSubmitted=false;
    this.largeProviderModal = true;
  }
  exportExcel() {
    let exp_data = this.users.map(function(aUser){
      return {Name: aUser.userFullName,
             Role: aUser.title,
             'Suburb (Pref Location)': aUser.prefLocationName,
             Region: aUser.region, 
             Notes: aUser.staffingNotes,
             travel:aUser.travelStatus,
             '2-for-1':aUser.twofourone


            };
    })
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(exp_data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "staffingReport_"+this.requestedPeriodDetails);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      });
  }
  get flprovidername () {
    return this.addlargeproviderform.get('flprovidername');
  }
 
  get updatelargeprovidergroup() {
    return this.registerForm.get('updatelargeprovidergroup');
  }
}
